import { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';
import * as adminApi from '../../../../services/api/adminApi';
import { getErrorMessage } from '../../../../utils/apiError';

export default function useAppSettings() {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchSettings = useCallback(() => {
        setLoading(true);
        adminApi.fetchSettings()
            .then(setSettings)
            .catch(err => message.error(getErrorMessage(err, 'Failed to load settings')))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    const setRegistrationEnabled = async (registrationEnabled) => {
        try {
            const updated = await adminApi.updateSettings({ registrationEnabled });
            setSettings(updated);
            message.success(registrationEnabled ? 'Registration enabled' : 'Registration disabled');
            return true;
        } catch (err) {
            message.error(getErrorMessage(err, 'Failed to update settings'));
            return false;
        }
    };

    return { settings, loading, setRegistrationEnabled };
}
